
class StockToBuyApi {

    getList({ page = 1, itemsPerPage = 10, sorter = null, filters = {}, search = '' }) {
        let url = apiUrl + 'stocktobuys';

        // Build query string parameters
        const params = new URLSearchParams();

        params.append('page', page);
        params.append('itemsPerPage', itemsPerPage);

        if (sorter?.column) {
            params.append('sortColumn', sorter.column);
            params.append('sortAsc', sorter.asc);
        }

        if (search) {
            params.append('search', search);
        }

        // Append filters to the query string
        Object.keys(filters).forEach((key) => {
            if (filters[key]) {
                params.append(`filters[${key}]`, filters[key]);
            }
        });

        // Add query string to URL
        url += `?${params.toString()}`;

        console.log(url);

        return api.call('get', url).then(({ data }) => {
            return data; // Expected to return { items, totalItems }
        });
    }

    updateImagePosition(data) {
        var url = apiUrl + 'stocktobuys/imageposition/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }

    deleteVehicleImage(imageId) {
        var url = apiUrl + 'stocktobuys/image/';
        return api.call('delete', url + imageId)
            .then(({ data }) => {
                return data
            });
    }



    updateVehicleImages(id, data) {
        var url = apiUrl + 'stocktobuys/UpdateVehicleImages/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }
    updateDefaultImages(data) {
        var url = apiUrl + 'stocktobuys/defaultimage/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    getListWithoutFilter() {
        var url = apiUrl + 'stocktobuys';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }


    get(id) {
        var url = apiUrl + 'stocktobuys/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }

    create(data) {
        var url = apiUrl + 'stocktobuys';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }
    update(data) {
        var url = apiUrl + 'stocktobuys/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }

    moveToStockConfirmation(id) {
        var url = apiUrl + 'stocktobuys/MoveToStock/';
        return api.call('put', url + id)
            .then(({ data }) => {
                return data
            });
    }

    delete(id) {
        var url = apiUrl + 'stocktobuys/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }


}

export default StockToBuyApi;